jQuery(document).ready(function ($) {
  let timer = null;

  $('.ajax-search-block .wp-block-search__input').on('keyup', function () {
    clearTimeout(timer);

    const query = $(this).val();
    if (query.length < 2) {
      $('.ajax-search-results').empty();
      return;
    }

    timer = setTimeout(() => {
      $('.ajax-search-block .loader').addClass('show');
      $.ajax({
        url: ajaxSearch.ajax_url,
        type: 'POST',
        data: {
          action: 'ajax_search',
          query: query,
        },
        success: function (response) {
          $('.ajax-search-block .ajax-search-results').html(response);
          $('.ajax-search-block .loader').removeClass('show');
        },
      });
    }, 300);
  });
});
